import React, { useEffect, useState } from "react";
import { CCollapse, CLink } from "@coreui/react";
import { Formik, Form, Field } from "formik";
import config from "../../config/config";
import axios from "axios";

import { toastError, toastSuccess } from "../../common/Toast";
import Loader from "../Loader/Loader";

const SingleSignOnInfo = (props) => {
  const [visibleSingleSignOnInfo, setVisibleSingleSignOnInfo] = useState(false);
  const [formValues, setFormValues] = useState({
    SSOProtocol: "",
    SingleSignOnServiceURL: " ",
    SingleLogOutServiceURL: "",
    X509Certificate: "",
    IdentityProviderEntityIDMetadata: "",
    SamlNameIDFormat: "",
    SAMLGroupsFieldName: "",
    SAMLLocationsField: "",
    FirstNameFieldName: "",
    LastNameFieldName: "",
    EMailFieldName: "",
    OIDCHost: "",
    OIDCClientID: "",
    OIDCSecret: "",
    OIDCCertificateURL: "",
    OIDCAdditionalScopes: "",
    OIDCUsernameField: "",
    OIDCGroupsField: "",
    OIDCLocationsField: "",
    OnlyAllowSSOLogins: false,
  });
  const token = localStorage.getItem("Token");
  const [comingSingleSignOnInfo, setcomingSingleSignOnInfo] = useState(
    props.visibleSingleSignOnInfoChanges
  );
  const [loading, setLoading] = useState(false);
  const [ssoprotocoloidc, setSSOProtocoloidc] = useState(true);
  const [ssoprotocolsaml, setSSOProtocolsaml] = useState(false);

  const handleSSOProtocoloidc = (e) => {
    if (e.target.value === "saml") {
      setSSOProtocoloidc(false);
      setSSOProtocolsaml(true);
    } else {
      setSSOProtocoloidc(true);
      setSSOProtocolsaml(false);
    }
  };

  //handleChange
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    const fieldValue = type === "checkbox" ? checked : value;

    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: fieldValue,
    }));
  };

  const handleSubmit = (values) => {
    const formArray = [
      { AppConfigkey: "SSOProtocol", AppConfigvalue: values.SSOProtocol },
      {
        AppConfigkey: "SingleSignOnServiceURL",
        AppConfigvalue: values.SingleSignOnServiceURL,
      },
      {
        AppConfigkey: "SingleLogOutServiceURL",
        AppConfigvalue: values.SingleLogOutServiceURL,
      },
      {
        AppConfigkey: "X509Certificate",
        AppConfigvalue: values.X509Certificate,
      },
      {
        AppConfigkey: "IdentityProviderEntityIDMetadata",
        AppConfigvalue: values.IdentityProviderEntityIDMetadata,
      },
      {
        AppConfigkey: "SamlNameIDFormat",
        AppConfigvalue: values.SamlNameIDFormat,
      },
      {
        AppConfigkey: "SAMLGroupsFieldName",
        AppConfigvalue: values.SAMLGroupsFieldName,
      },
      {
        AppConfigkey: "SAMLLocationsField",
        AppConfigvalue: values.SAMLLocationsField,
      },
      {
        AppConfigkey: "FirstNameFieldName",
        AppConfigvalue: values.FirstNameFieldName,
      },
      {
        AppConfigkey: "LastNameFieldName",
        AppConfigvalue: values.LastNameFieldName,
      },
      { AppConfigkey: "EMailFieldName", AppConfigvalue: values.EMailFieldName },
      { AppConfigkey: "OIDCHost", AppConfigvalue: values.OIDCHost },
      { AppConfigkey: "OIDCClientID", AppConfigvalue: values.OIDCClientID },
      { AppConfigkey: "OIDCSecret", AppConfigvalue: values.OIDCSecret },
      {
        AppConfigkey: "OIDCCertificateURL",
        AppConfigvalue: values.OIDCCertificateURL,
      },
      {
        AppConfigkey: "OIDCAdditionalScopes",
        AppConfigvalue: values.OIDCAdditionalScopes,
      },
      {
        AppConfigkey: "OIDCUsernameField",
        AppConfigvalue: values.OIDCUsernameField,
      },
      {
        AppConfigkey: "OIDCGroupsField",
        AppConfigvalue: values.OIDCGroupsField,
      },
      {
        AppConfigkey: "OIDCLocationsField",
        AppConfigvalue: values.OIDCLocationsField,
      },
      {
        AppConfigkey: "OnlyAllowSSOLogins",
        AppConfigvalue: values.OnlyAllowSSOLogins,
      },
    ];

    const jsonobj = {};
    jsonobj.StoreConfig = formArray;

    let jsonstring = JSON.stringify(jsonobj);

    setLoading(true);

    axios
      .post(
        `${config.storeConfigBaseUrl}/storeconfig/upsert`,
        {
          type: "SingleSignOnInfo",
          storeconfigxml: jsonstring,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS" && res.data.ResponseID > 0) {
          toastSuccess("Record has been added!");
        } else {
          toastError("Somthing went wrong");
        }

        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };
  useEffect(() => {
    setLoading(true);

    axios
      .get(
        `${config.storeConfigBaseUrl}/storeconfig/getallconfig?type=SingleSignOnInfo`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )
      .then((response) => {
        const responseData = response.data.ResponseData;

        responseData.map((data) => {
          if (data.AppConfigkey === "SSOProtocol") {
            formValues.SSOProtocol = data.AppConfigvalue;
          } else if (data.AppConfigkey === "SingleSignOnServiceURL") {
            formValues.SingleSignOnServiceURL = data.AppConfigvalue;
          } else if (data.AppConfigkey === "SingleLogOutServiceURL") {
            formValues.SingleLogOutServiceURL = data.AppConfigvalue;
          } else if (data.AppConfigkey === "X509Certificate") {
            formValues.X509Certificate = data.AppConfigvalue;
          } else if (data.AppConfigkey === "IdentityProviderEntityIDMetadata") {
            formValues.IdentityProviderEntityIDMetadata = data.AppConfigvalue;
          } else if (data.AppConfigkey === "SamlNameIDFormat") {
            formValues.SamlNameIDFormat = data.AppConfigvalue;
          } else if (data.AppConfigkey === "SAMLGroupsFieldName") {
            formValues.SAMLGroupsFieldName = data.AppConfigvalue;
          } else if (data.AppConfigkey === "SAMLLocationsField") {
            formValues.SAMLLocationsField = data.AppConfigvalue;
          } else if (data.AppConfigkey === "FirstNameFieldName") {
            formValues.FirstNameFieldName = data.AppConfigvalue;
          } else if (data.AppConfigkey === "LastNameFieldName") {
            formValues.LastNameFieldName = data.AppConfigvalue;
          } else if (data.AppConfigkey === "OIDCHost") {
            formValues.OIDCHost = data.AppConfigvalue;
          } else if (data.AppConfigkey === "OIDCClientID") {
            formValues.OIDCClientID = data.AppConfigvalue;
          } else if (data.AppConfigkey === "OIDCSecret") {
            formValues.OIDCSecret = data.AppConfigvalue;
          } else if (data.AppConfigkey === "OIDCCertificateURL") {
            formValues.OIDCCertificateURL = data.AppConfigvalue;
          } else if (data.AppConfigkey === "OIDCAdditionalScopes") {
            formValues.OIDCAdditionalScopes = data.AppConfigvalue;
          } else if (data.AppConfigkey === "OIDCUsernameField") {
            formValues.OIDCUsernameField = data.AppConfigvalue;
          } else if (data.AppConfigkey === "OIDCGroupsField") {
            formValues.OIDCGroupsField = data.AppConfigvalue;
          } else if (data.AppConfigkey === "OIDCLocationsField") {
            formValues.OIDCLocationsField = data.AppConfigvalue;
          } else if (data.AppConfigkey === "OnlyAllowSSOLogins") {
            formValues.OnlyAllowSSOLogins =
              data.AppConfigvalue === "false" ? false : true;
          }
        });

        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  }, []);

  const data = [
    {
      name: " SSO Protocol:",
      input: (
        <>
          <div
            className="col-lg-8"
            style={{
              width: "200px",
              marginLeft: "20px",
            }}
          >
            <div className="input-group">
              <Field
                width="400px"
                as="select"
                className="form-control form-small select"
                id="SSOProtocol"
                name="SSOProtocol"
                onInput={handleSSOProtocoloidc}
                onChange={handleChange}
              >
                <option>saml</option>
                <option>oidc</option>
              </Field>
            </div>
          </div>

          {/* saml Fields */}

          {/* <div
            className={`form-group row ${ssoprotocolsaml === true ? "" : "d-none"
              }`}
          >
            <label className="col-form-label col-lg-2">
              Single Sign On Service URL:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="SingleSignOnServiceURL"
                  name="SingleSignOnServiceURL"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div> */}
          {/* <div
            className={`form-group row ${ssoprotocolsaml === true ? "" : "d-none"
              }`}
          >
            <label className="col-form-label col-lg-2">
              Single Log Out Service URL:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="SingleLogOutServiceURL"
                  name="SingleLogOutServiceURL"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${ssoprotocolsaml === true ? "" : "d-none"
              }`}
          >
            <label className="col-form-label col-lg-2">
              X509 Certificate:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  as="textarea"
                  type="text"
                  className="form-control"
                  id="X509Certificate"
                  name="X509Certificate"
                  rows={3}
                  onChange={handleChange}
                ></Field>
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${ssoprotocolsaml === true ? "" : "d-none"
              }`}
          >
            <label className="col-form-label col-lg-2">
              Identity Provider Entity ID (Metadata):
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="IdentityProviderEntityIDMetadata"
                  name="IdentityProviderEntityIDMetadata"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${ssoprotocolsaml === true ? "" : "d-none"
              }`}
          >
            <label className="col-form-label col-lg-2">
              Saml Name ID Format:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="SamlNameIDFormat"
                  name="SamlNameIDFormat"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${ssoprotocolsaml === true ? "" : "d-none"
              }`}
          >
            <label className="col-form-label col-lg-2">
              SAML Groups Field Name:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="SAMLGroupsFieldName"
                  name="SAMLGroupsFieldName"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${ssoprotocolsaml === true ? "" : "d-none"
              }`}
          >
            <label className="col-form-label col-lg-2">
              SAML Locations Field:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="SAMLLocationsField"
                  name="SAMLLocationsField"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${ssoprotocolsaml === true ? "" : "d-none"
              }`}
          >
            <label className="col-form-label col-lg-2">
              First Name Field Name:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="FirstNameFieldName"
                  name="FirstNameFieldName"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${ssoprotocolsaml === true ? "" : "d-none"
              }`}
          >
            <label className="col-form-label col-lg-2">
              Last Name Field Name:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="LastNameFieldName"
                  name="LastNameFieldName"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${ssoprotocolsaml === true ? "" : "d-none"
              }`}
          >
            <label className="col-form-label col-lg-2">
              E-Mail Field Name:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="EMailFieldName"
                  name="EMailFieldName"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div> */}

          {/* oidc Fields */}

          {/* <div
            className={`form-group row ${ssoprotocoloidc === true ? "" : "d-none"
              }`}
          >
            <label className="col-form-label col-lg-2">
              OIDC Host:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="OIDCHost"
                  name="OIDCHost"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${ssoprotocoloidc === true ? "" : "d-none"
              }`}
          >
            <label className="col-form-label col-lg-2">
              OIDC Client ID:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="OIDCClientID"
                  name="OIDCClientID"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${ssoprotocoloidc === true ? "" : "d-none"
              }`}
          >
            <label className="col-form-label col-lg-2">
              OIDC Secret:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="OIDCSecret"
                  name="OIDCSecret"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${ssoprotocoloidc === true ? "" : "d-none"
              }`}
          >
            <label className="col-form-label col-lg-2">
              OIDC Certificate URL:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="OIDCCertificateURL"
                  name="OIDCCertificateURL"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${ssoprotocoloidc === true ? "" : "d-none"
              }`}
          >
            <label className="col-form-label col-lg-2">
              OIDC Additional Scopes:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="OIDCAdditionalScopes"
                  name="OIDCAdditionalScopes"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${ssoprotocoloidc === true ? "" : "d-none"
              }`}
          >
            <label className="col-form-label col-lg-2">
              OIDC Username Field:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="OIDCUsernameField"
                  name="OIDCUsernameField"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${ssoprotocoloidc === true ? "" : "d-none"
              }`}
          >
            <label className="col-form-label col-lg-2">
              OIDC Groups Field:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="OIDCGroupsField"
                  name="OIDCGroupsField"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
          <div
            className={`form-group row ${ssoprotocoloidc === true ? "" : "d-none"
              }`}
          >
            <label className="col-form-label col-lg-2">
              OIDC Locations Field:
            </label>
            <div className="col-lg-10">
              <div className="input-group">
                <Field
                  type="text"
                  className="form-control"
                  id="OIDCLocationsField"
                  name="OIDCLocationsField"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div> */}
        </>
      ),
    },
    {
      name: "Only Allow SSO Logins:",
      input: (
        <>
          <div
            className="col-lg-10"
            style={{
              marginTop: "10px",
              marginLeft: "20px",
              height: "2rem",
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <div className="input-group">
              <Field
                className="form-check-input"
                style={{ width: "20px" }}
                type="checkbox"
                id="OnlyAllowSSOLogins"
                name="OnlyAllowSSOLogins"
                onChange={handleChange}
              />
            </div>
          </div>
        </>
      ),
    },
  ];

  const matchesSearchQuery = data?.filter((el) => {
    return el?.name?.toLowerCase().includes(props.searchQuery.toLowerCase());
  });

  return (
    <>
      {/*  */}
      {/* <Loader loading={loading} /> */}
      {matchesSearchQuery.length === data.length ? (
        <div className="card">
          <div
            style={{ padding: "0px", marginTop: "16px", marginLeft: "18px" }}
            className="card-header"
          >
            <h5 className="card-title">
              <CLink
                style={{ color: "var(--primary-main-color)" }}
                onClick={() => {
                  setVisibleSingleSignOnInfo(!visibleSingleSignOnInfo);
                  setcomingSingleSignOnInfo(!!comingSingleSignOnInfo);
                }}
              >
                Single Sign On (SSO) Info
              </CLink>
            </h5>
          </div>
          <CCollapse
            visible={
              visibleSingleSignOnInfo || props.visibleSingleSignOnInfoChanges
            }
          >
            <div className="card-body">
              <Formik
                {...props}
                initialValues={formValues}
                onSubmit={handleSubmit}
                enableReinitialize
              >
                {({ handleChange }) => (
                  <Form>
                    <div className="">
                      {matchesSearchQuery &&
                        matchesSearchQuery?.map((el) => (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "flex-start",
                            }}
                          >
                            <label
                              className="col-form-label"
                              style={{ fontSize: "15px" }}
                            >
                              {el.name}
                            </label>
                            <div>{el.input}</div>
                          </div>
                        ))}
                    </div>
                    {/* <div className="form-group row">
                          <label className="col-form-label col-lg-2">
                            SSO Protocol:
                          </label>
                          <div className="col-lg-10">
                            <div className="input-group">
                              <Field
                                as="select"
                                className="form-control form-small select"
                                id="SSOProtocol"
                                name="SSOProtocol"
                                onInput={handleSSOProtocoloidc}
                                onChange={handleChange}
                              >
                                <option>saml</option>
                                <option>oidc</option>
                              </Field>
                            </div>
                          </div>
                        </div> */}

                    {/* saml Fields */}

                    <div
                      className={`form-group row ${
                        ssoprotocolsaml === true ? "" : "d-none"
                      }`}
                    >
                      <label className="col-form-label col-lg-2">
                        Single Sign On Service URL:
                      </label>
                      <div className="col-lg-6">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="SingleSignOnServiceURL"
                            name="SingleSignOnServiceURL"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${
                        ssoprotocolsaml === true ? "" : "d-none"
                      }`}
                    >
                      <label className="col-form-label col-lg-2">
                        Single Log Out Service URL:
                      </label>
                      <div className="col-lg-6">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="SingleLogOutServiceURL"
                            name="SingleLogOutServiceURL"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${
                        ssoprotocolsaml === true ? "" : "d-none"
                      }`}
                    >
                      <label className="col-form-label col-lg-2">
                        X509 Certificate:
                      </label>
                      <div className="col-lg-6">
                        <div className="input-group">
                          <Field
                            as="textarea"
                            type="text"
                            className="form-control"
                            id="X509Certificate"
                            name="X509Certificate"
                            rows={3}
                            onChange={handleChange}
                          ></Field>
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${
                        ssoprotocolsaml === true ? "" : "d-none"
                      }`}
                    >
                      <label className="col-form-label col-lg-2">
                        Identity Provider Entity ID (Metadata):
                      </label>
                      <div className="col-lg-6">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="IdentityProviderEntityIDMetadata"
                            name="IdentityProviderEntityIDMetadata"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${
                        ssoprotocolsaml === true ? "" : "d-none"
                      }`}
                    >
                      <label className="col-form-label col-lg-2">
                        Saml Name ID Format:
                      </label>
                      <div className="col-lg-6">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="SamlNameIDFormat"
                            name="SamlNameIDFormat"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${
                        ssoprotocolsaml === true ? "" : "d-none"
                      }`}
                    >
                      <label className="col-form-label col-lg-2">
                        SAML Groups Field Name:
                      </label>
                      <div className="col-lg-6">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="SAMLGroupsFieldName"
                            name="SAMLGroupsFieldName"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${
                        ssoprotocolsaml === true ? "" : "d-none"
                      }`}
                    >
                      <label className="col-form-label col-lg-2">
                        SAML Locations Field:
                      </label>
                      <div className="col-lg-6">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="SAMLLocationsField"
                            name="SAMLLocationsField"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${
                        ssoprotocolsaml === true ? "" : "d-none"
                      }`}
                    >
                      <label className="col-form-label col-lg-2">
                        First Name Field Name:
                      </label>
                      <div className="col-lg-6">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="FirstNameFieldName"
                            name="FirstNameFieldName"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${
                        ssoprotocolsaml === true ? "" : "d-none"
                      }`}
                    >
                      <label className="col-form-label col-lg-2">
                        Last Name Field Name:
                      </label>
                      <div className="col-lg-6">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="LastNameFieldName"
                            name="LastNameFieldName"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${
                        ssoprotocolsaml === true ? "" : "d-none"
                      }`}
                    >
                      <label className="col-form-label col-lg-2">
                        E-Mail Field Name:
                      </label>
                      <div className="col-lg-6">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="EMailFieldName"
                            name="EMailFieldName"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>

                    {/* oidc Fields */}

                    <div
                      className={`form-group row ${
                        ssoprotocoloidc === true ? "" : "d-none"
                      }`}
                    >
                      <label className="col-form-label col-lg-2">
                        OIDC Host:
                      </label>
                      <div className="col-lg-6">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="OIDCHost"
                            name="OIDCHost"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${
                        ssoprotocoloidc === true ? "" : "d-none"
                      }`}
                    >
                      <label className="col-form-label col-lg-2">
                        OIDC Client ID:
                      </label>
                      <div className="col-lg-6">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="OIDCClientID"
                            name="OIDCClientID"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${
                        ssoprotocoloidc === true ? "" : "d-none"
                      }`}
                    >
                      <label className="col-form-label col-lg-2">
                        OIDC Secret:
                      </label>
                      <div className="col-lg-6">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="OIDCSecret"
                            name="OIDCSecret"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${
                        ssoprotocoloidc === true ? "" : "d-none"
                      }`}
                    >
                      <label className="col-form-label col-lg-2">
                        OIDC Certificate URL:
                      </label>
                      <div className="col-lg-6">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="OIDCCertificateURL"
                            name="OIDCCertificateURL"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${
                        ssoprotocoloidc === true ? "" : "d-none"
                      }`}
                    >
                      <label className="col-form-label col-lg-2">
                        OIDC Additional Scopes:
                      </label>
                      <div className="col-lg-6">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="OIDCAdditionalScopes"
                            name="OIDCAdditionalScopes"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${
                        ssoprotocoloidc === true ? "" : "d-none"
                      }`}
                    >
                      <label className="col-form-label col-lg-2">
                        OIDC Username Field:
                      </label>
                      <div className="col-lg-6">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="OIDCUsernameField"
                            name="OIDCUsernameField"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${
                        ssoprotocoloidc === true ? "" : "d-none"
                      }`}
                    >
                      <label className="col-form-label col-lg-2">
                        OIDC Groups Field:
                      </label>
                      <div className="col-lg-6">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="OIDCGroupsField"
                            name="OIDCGroupsField"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>
                    <div
                      className={`form-group row ${
                        ssoprotocoloidc === true ? "" : "d-none"
                      }`}
                    >
                      <label className="col-form-label col-lg-2">
                        OIDC Locations Field:
                      </label>
                      <div className="col-lg-6">
                        <div className="input-group">
                          <Field
                            type="text"
                            className="form-control"
                            id="OIDCLocationsField"
                            name="OIDCLocationsField"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div>

                    {/* comman fileds */}
                    {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Only Allow SSO Logins:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="OnlyAllowSSOLogins"
                            name="OnlyAllowSSOLogins"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                    <button
                      type="submit"
                      className="btn btn-primary pull-right mb-3"
                    >
                      Save
                    </button>
                  </Form>
                )}
              </Formik>
            </div>
          </CCollapse>
        </div>
      ) : (
        matchesSearchQuery.length !== 0 && (
          <div className="card">
            <div className="card-header">
              <h5 className="card-title">
                <CLink
                  onClick={() => {
                    setVisibleSingleSignOnInfo(!visibleSingleSignOnInfo);
                    setcomingSingleSignOnInfo(!!comingSingleSignOnInfo);
                  }}
                >
                  Single Sign On (SSO) Info
                </CLink>
              </h5>
            </div>
            <CCollapse
              visible={
                visibleSingleSignOnInfo || props.visibleSingleSignOnInfoChanges
              }
            >
              <div className="card-body">
                <Formik
                  {...props}
                  initialValues={formValues}
                  onSubmit={handleSubmit}
                  enableReinitialize
                >
                  {({ handleChange }) => (
                    <Form>
                      <div className="">
                        {matchesSearchQuery &&
                          matchesSearchQuery?.map((el) => (
                            <div
                              style={{
                                display: "flex",
                                justifyContent: "space-evenly",
                              }}
                            >
                              <label
                                className="col-form-label"
                                style={{ fontSize: "15px" }}
                              >
                                {el.name}
                              </label>
                              <div>{el.input}</div>
                            </div>
                          ))}
                      </div>
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2">
                        SSO Protocol:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            as="select"
                            className="form-control form-small select"
                            id="SSOProtocol"
                            name="SSOProtocol"
                            onInput={handleSSOProtocoloidc}
                            onChange={handleChange}
                          >
                            <option>saml</option>
                            <option>oidc</option>
                          </Field>
                        </div>
                      </div>
                    </div> */}

                      {/* saml Fields */}

                      <div
                        className={`form-group row ${
                          ssoprotocolsaml === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          Single Sign On Service URL:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="SingleSignOnServiceURL"
                              name="SingleSignOnServiceURL"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          ssoprotocolsaml === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          Single Log Out Service URL:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="SingleLogOutServiceURL"
                              name="SingleLogOutServiceURL"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          ssoprotocolsaml === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          X509 Certificate:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              as="textarea"
                              type="text"
                              className="form-control"
                              id="X509Certificate"
                              name="X509Certificate"
                              rows={3}
                              onChange={handleChange}
                            ></Field>
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          ssoprotocolsaml === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          Identity Provider Entity ID (Metadata):
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="IdentityProviderEntityIDMetadata"
                              name="IdentityProviderEntityIDMetadata"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          ssoprotocolsaml === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          Saml Name ID Format:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="SamlNameIDFormat"
                              name="SamlNameIDFormat"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          ssoprotocolsaml === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          SAML Groups Field Name:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="SAMLGroupsFieldName"
                              name="SAMLGroupsFieldName"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          ssoprotocolsaml === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          SAML Locations Field:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="SAMLLocationsField"
                              name="SAMLLocationsField"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          ssoprotocolsaml === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          First Name Field Name:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="FirstNameFieldName"
                              name="FirstNameFieldName"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          ssoprotocolsaml === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          Last Name Field Name:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="LastNameFieldName"
                              name="LastNameFieldName"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          ssoprotocolsaml === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          E-Mail Field Name:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="EMailFieldName"
                              name="EMailFieldName"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>

                      {/* oidc Fields */}

                      <div
                        className={`form-group row ${
                          ssoprotocoloidc === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          OIDC Host:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="OIDCHost"
                              name="OIDCHost"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          ssoprotocoloidc === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          OIDC Client ID:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="OIDCClientID"
                              name="OIDCClientID"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          ssoprotocoloidc === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          OIDC Secret:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="OIDCSecret"
                              name="OIDCSecret"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          ssoprotocoloidc === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          OIDC Certificate URL:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="OIDCCertificateURL"
                              name="OIDCCertificateURL"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          ssoprotocoloidc === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          OIDC Additional Scopes:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="OIDCAdditionalScopes"
                              name="OIDCAdditionalScopes"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          ssoprotocoloidc === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          OIDC Username Field:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="OIDCUsernameField"
                              name="OIDCUsernameField"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          ssoprotocoloidc === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          OIDC Groups Field:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="OIDCGroupsField"
                              name="OIDCGroupsField"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>
                      <div
                        className={`form-group row ${
                          ssoprotocoloidc === true ? "" : "d-none"
                        }`}
                      >
                        <label className="col-form-label col-lg-2">
                          OIDC Locations Field:
                        </label>
                        <div className="col-lg-10">
                          <div className="input-group">
                            <Field
                              type="text"
                              className="form-control"
                              id="OIDCLocationsField"
                              name="OIDCLocationsField"
                              onChange={handleChange}
                            />
                          </div>
                        </div>
                      </div>

                      {/* comman fileds */}
                      {/* <div className="form-group row">
                      <label className="col-form-label col-lg-2 ">
                        Only Allow SSO Logins:
                      </label>
                      <div className="col-lg-10">
                        <div className="input-group">
                          <Field
                            className="form-check-input"
                            style={{ width: "1.5em", height: "1.5em" }}
                            type="checkbox"
                            id="OnlyAllowSSOLogins"
                            name="OnlyAllowSSOLogins"
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                    </div> */}
                      <button
                        type="submit"
                        className="btn btn-primary pull-right mb-3"
                      >
                        Save
                      </button>
                    </Form>
                  )}
                </Formik>
              </div>
            </CCollapse>
          </div>
        )
      )}
    </>
  );
};

export default SingleSignOnInfo;
